import React from "react"
import { translate } from "react-i18next"
import PropTypes from "prop-types"
import Widget from "../layout/widget/Widget"
import ColumnChart from "../charts/generic/ColumnChart"
import ItemNameCountShape from "../../state/shapes/ItemNameCountShape"
import { formatDecimalForDisplay } from "../../utils/formatting-utils"

function Freedom({ exportEndpoint, data, appliedFilters, t }) {
  const barChartData = {
    categories: [],
    bars: []
  }

  const singleDataItem = {
    data: [],
    showInLegend: false
  }

  data.forEach(d => {
    barChartData.categories.push(d.itemName)
    singleDataItem.data.push({ y: d.percentage, count: d.count })
  })
  barChartData.bars.push(singleDataItem)

  const formatTooltip = context => {
    if (context.point.count === 1) {
      return `<b>${context.x}:</b> 
      ${formatDecimalForDisplay(context.y)}% (${context.point.count} ${t("Common.Person")})`
    }
    
    return `<b>${context.x}:</b> 
    ${formatDecimalForDisplay(context.y)}% (${context.point.count} ${t("Common.People")})`
  }

  const titleKey="Widgets.Freedom.Title"
  return (
    <Widget
      columns={2}
      titleKey={titleKey}
      helpKey="Widgets.HowMuchFreedom.Help"
      exportEndpoint={exportEndpoint}
      appliedFilters={appliedFilters}
    >
      <ColumnChart
        data={barChartData}
        yAxisTitle="Common.Percentage"
        xAxisTitle="Widgets.Freedom.Scale"
        chartType="column"
        tooltipFormatter={formatTooltip}
        titleKey={titleKey}
      />
    </Widget>
  )
}

Freedom.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape(ItemNameCountShape)).isRequired,
  exportEndpoint: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired
}

export default translate()(Freedom)



// WEBPACK FOOTER //
// ./src/components/widgets/Freedom.jsx